import { visitorRetentionSettingDTOSchema, } from '@instanexus/contracts';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const settingSchema = dataEnvelopeSchema(visitorRetentionSettingDTOSchema);
const RETENTION_PATH = `${WEB_API_PREFIX}/visitor/retention-settings`;
export function createRetentionSettingsResource(transport) {
    return {
        async get() {
            const envelope = await transport.request({ path: RETENTION_PATH, schema: settingSchema });
            return envelope.data;
        },
        async update(input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: RETENTION_PATH,
                schema: settingSchema,
                body: input,
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=retention-settings.js.map